/* =========================================================
   INDILOOM THEME | home.js  (catalogue grid: filter chips + load more)
   Loaded with defer only by sections/catalogue-grid.liquid
   Cards after the first step live in <template data-catalogue-rest>
   and are only added to the page when Load more or a filter is used.
   ========================================================= */
(function () {
  'use strict';
  function init(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-catalogue]')).forEach(function (wrap) {
      if (wrap.ilCat) return; wrap.ilCat = true;
      var grid = wrap.querySelector('[data-catalogue-grid]');
      var tpl = wrap.querySelector('template[data-catalogue-rest]');
      var cards = Array.prototype.slice.call(grid.children);
      var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-filter-match]'));
      var btn = wrap.querySelector('[data-catalogue-btn]'), info = wrap.querySelector('[data-catalogue-info]'), bar = wrap.querySelector('[data-catalogue-bar]');
      var step = parseInt(wrap.getAttribute('data-step'), 10) || 12, shown = step, match = 'all', value = '';
      var total = parseInt(grid.getAttribute('data-total'), 10) || cards.length;

      function expand() {
        if (!tpl) return;
        var frag = tpl.content;
        Array.prototype.slice.call(frag.children).forEach(function (c) { c.hidden = true; });
        grid.appendChild(frag);
        tpl.parentNode.removeChild(tpl); tpl = null;
        cards = Array.prototype.slice.call(grid.children);
        if (window.ilInit) window.ilInit(grid);
      }
      function ok(card) {
        if (match === 'all') return true;
        var d = card.dataset;
        switch (match) {
          case 'tag': return (d.tags || '').split('|').indexOf(value) > -1;
          case 'type': return (d.type || '') === value;
          case 'vendor': return (d.vendor || '') === value;
          case 'price_under': return Number(d.price) < parseFloat(value) * 100;
          case 'price_over': return Number(d.price) >= parseFloat(value) * 100;
        }
        return true;
      }
      function paint(vis, len) {
        if (info) info.textContent = len ? 'Showing ' + vis + ' of ' + len + ' products' : 'No products match this filter';
        if (bar) bar.value = len ? Math.round(vis / len * 100) : 100;
        if (btn) btn.hidden = vis >= len;
      }
      function render(animate) {
        expand();
        var list = cards.filter(ok);
        cards.forEach(function (c) { c.hidden = true; c.classList.remove('il-fade'); });
        list.forEach(function (c, n) { if (n < shown) { c.hidden = false; if (animate) c.classList.add('il-fade'); } });
        paint(Math.min(shown, list.length), list.length);
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          match = c.getAttribute('data-filter-match'); value = c.getAttribute('data-filter-value') || '';
          shown = step; render(true);
        });
      });
      if (btn) btn.addEventListener('click', function () { shown += step; render(true); });
      paint(Math.min(step, total), total);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
